/* global FB */
Pixlee.module('UploaderV3App.Show', function(Show, App, Backbone, Marionette, $) {
    Show.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            if (!App.hasTOS) {
                // We can't open the uploader if there is no TOS
                // Close it right away.
                // We are doing this here, since we can't block the uploader from being opened in the first place:
                // The decision to open the uploader is made in pixlee_widget.1.0.1.js (https://github.com/pixlee/photos/blob/c9ad0e38caa5701ffb90ba338f77a79c5569329b/public/javascripts/embed/widget/pixlee_widget.1.0.1.js#L311)
                // and we don't have access to display options or App.hasTOS there.
                window.parent.postMessage(JSON.stringify({
                    name: 'pixlee:close:uploader',
                    type: 'action',
                    source: 'uploader',
                    destination: 'parent',
                    data: {}
                }), '*');
                return;
            }
            var _this = this;
            this.initKeenData();
            // Needed because desktop submissions executes onShow by the number of photos in the collection
            this.keenUploadMediaDebounce = _.debounce(function(keenData) {
                _this.keenUploadMedia(keenData);
            }, 600, false);
            // Initialize all uploader collections needed
            this.initUploaderCollections();
            // Social Accounts
            Show.connectedUser = new App.Entities.Model();
            this.source = '';

            // Get two main views
            this.layout = new Show.Layout({
                currentAlbum: options.current_album
            });
            this.homeView = new Show.Home();
            // Set two views events
            this.setHomeViewEvents(this.homeView);
            this.setLayoutEvents(this.layout, this.homeView);
            // Show two main views
            this.showLayout(this.layout);
            this.showHomeView(this.homeView);
            // Preview Mode
            if (!_.isFalsy(gon.previewMode)) {
                this.setPreviewMode();
            }
        },

        setLayoutEvents: function(layoutView) {
            this.listenTo(layoutView, 'show:home:view', function() {
                this.initUploaderCollections();
                this.initKeenData();
                layoutView.mainContent.destroy(this.homeView);
                this.homeView = new Show.Home();
                this.setHomeViewEvents(this.homeView);
                this.showHomeView(this.homeView);
            });
            this.listenTo(layoutView, 'check:pick:source', function() {
                if (this.uploaderCollection.length > 0) {
                    this.layout.onShowUploaderBackAlert();
                } else {
                    this.layout.trigger('show:home:view');
                }
            });
            this.listenTo(layoutView, 'check:select:content', function() {
                if (this.source === 'desktop' && this.uploaderCollection.length > 0) {
                    this.layout.onShowUploaderBackAlert('two');
                } else {
                    this.layout.trigger('show:select:content');
                }
            });
            this.listenTo(layoutView, 'show:select:content', function() {
                if (!this.uploaderCollection.length) {
                    this.keenUploadedMedia = false;
                }
                switch (this.source) {
                    case 'desktop':
                        this.homeView.trigger('show:desktop:drag:drop');
                        break;
                    case 'facebook':
                        this.homeView.trigger('show:facebook', this.facebookLogin);
                        break;
                    case 'google':
                        this.homeView.trigger('show:gphotos', this.googleLogin);
                        break;
                    default:
                        break;
                }
            });
            this.listenTo(layoutView, 'show:review:submission', function() {
                this.initReviewPanel(this.source);
            });
            this.listenTo(layoutView, 'show:submit:content', function() {
                this.showFormView(this.formView);
            });
            this.listenTo(layoutView, 'keen:opened:uploader', function() {
                App.execute('click:uploader', 'Opened uploader', this.keenData);
            });
            this.listenTo(layoutView, 'keen:clicked:navigation', function(navTo, navFromNumber) {
                var keenNavData = _.extend({
                    nav_to: navTo,
                    nav_from: this.keenMapStep(navFromNumber)
                }, this.keenData);
                App.execute('click:uploader', 'Clicked navigation', keenNavData);
            });
            this.listenTo(layoutView, 'keen:canceled:submission', function(currentStepNumber) {
                this.keenData.nav_from = this.keenMapStep(currentStepNumber);
                App.execute('click:uploader', 'Canceled submission', this.keenData);
            });
        },
        setInfoPanelEvents: function(infoPanel) {
            this.listenTo(infoPanel, {
                'get:focus:index': this.getFocusIndex.bind(this)
            });
        },
        setHomeViewEvents: function(homeView) {
            this.listenTo(homeView, {
                'get:focus:index': this.getFocusIndex.bind(this),
                'update:breadcrumb': this.updateBreadcrumb.bind(this),
                'show:info': function() {
                    this.infoPanel = new Show.InfoView();
                    this.setInfoPanelEvents(this.infoPanel);
                    this.showInfoPanel(this.infoPanel);
                },
                'show:desktop:drag:drop': function() {
                    this.source = 'desktop';
                    this.uploaderCollection = new App.Entities.Collection();
                    this.keenUploadedMedia = false;
                    this.dragDropView = new Show.DragDrop({
                        collection: this.uploaderCollection,
                        connectedUser: Show.connectedUser
                    });
                    this.setDragDropEvents(this.dragDropView);
                    this.showDragDropView(this.dragDropView);
                    // Keen Tracking
                    if (!this.keenSelectedChannel) {
                        this.initKeenData();
                        this.keenData.channel = 'desktop';
                        App.execute('click:uploader', 'Selected channel', this.keenData);
                        this.keenSelectedChannel = true;
                    }
                },
                'show:facebook': function(socialLogin) {
                    this.source = 'facebook';
                    this.facebookLogin = socialLogin;
                    Show.connectedUser.set({
                        'facebook_token': socialLogin.access_token,
                        'facebook_avatar': socialLogin.avatar_url,
                        'facebook_email_address': socialLogin.email_address,
                        'facebook_user_name': socialLogin.user_name,
                        'facebook_id': socialLogin.social_id
                    });
                    this.initFacebookSocialPhotoAlbumsPanel();
                    // Keen Tracking
                    if (!this.keenSelectedChannel) {
                        this.initKeenData();
                        this.keenData.channel = 'facebook';
                        App.execute('click:uploader', 'Selected channel', this.keenData);
                        this.keenSelectedChannel = true;
                    }
                },
                'show:gphotos': function(socialLogin) {
                    this.source = 'google';
                    this.googleLogin = socialLogin;
                    Show.connectedUser.set({
                        'google_token': socialLogin.access_token,
                        'google_avatar': socialLogin.avatar_url,
                        'google_email_address': socialLogin.email_address,
                        'google_user_name': socialLogin.user_name,
                        'google_id': socialLogin.extra_fields['google_id']
                    });
                    this.initGooglePickerPanel();
                    // Keen Tracking
                    if (!this.keenSelectedChannel) {
                        this.initKeenData();
                        this.keenData.channel = 'google';
                        App.execute('click:uploader', 'Selected channel', this.keenData);
                        this.keenSelectedChannel = true;
                    }
                }
            });
        },
        setReviewPanelEvents: function(reviewPanel) {
            this.listenTo(reviewPanel, {
                'get:focus:index': this.getFocusIndex.bind(this),
                'update:breadcrumb': this.updateBreadcrumb.bind(this),
                'show:product:search': function(photo, source) {
                    this.showProductSearchPanel(photo, source);
                },
                'show:submit:content': function() {
                    this.formView = new Show.FormView({
                        model: Show.connectedUser,
                        collection: this.uploaderCollection,
                        source: this.source
                    });
                    this.setFormViewEvents(this.formView, this);
                    this.showFormView(this.formView, this);
                    // Keen Tracking
                    App.execute('click:uploader', 'Confirmed submission', this.keenData);
                },
                'show:confirm:panel': function(uploadCompleteData) {
                    this.confirmPanel = new Show.ConfirmPanel();
                    this.setConfirmPanelEvents(this.confirmPanel, this);
                    this.showConfirmPanel(this.confirmPanel, uploadCompleteData);
                },
                'show:select:content': function() {
                    if (!this.uploaderCollection.length) {
                        this.keenUploadedMedia = false;
                    }
                    this.layout.trigger('show:select:content');
                }
            });
        },
        setDragDropEvents: function(dragDropView) {
            this.listenTo(dragDropView, {
                'get:focus:index': this.getFocusIndex.bind(this),
                'update:breadcrumb': this.updateBreadcrumb.bind(this),
                'show:alert': function(alert, data) {
                    this.layout.onShowAlert(alert, data);
                },
                'reset:view': function() {
                    this.dragDropView.destroy();
                    if (!this.uploaderCollection.length) {
                        this.keenUploadedMedia = false;
                    }
                    this.uploaderCollection = new App.Entities.Collection();
                    this.dragDropView = new Show.DragDrop({
                        collection: this.uploaderCollection,
                        connectedUser: Show.connectedUser
                    });
                    this.setDragDropEvents(this.dragDropView);
                    this.showDragDropView(this.dragDropView);
                },
                'show:review:panel': function(source) {
                    this.source = source;
                    this.initReviewPanel(source);
                },
                'show:confirm:panel': function(uploadCompleteData) {
                    this.confirmPanel = new Show.ConfirmPanel();
                    this.setConfirmPanelEvents(this.confirmPanel, this);
                    this.showConfirmPanel(this.confirmPanel, uploadCompleteData);
                }
            });
        },
        setFormViewEvents: function(formView) {
            this.listenTo(formView, {
                'get:focus:index': this.getFocusIndex.bind(this),
                'update:breadcrumb': this.updateBreadcrumb.bind(this),
                'show:confirm:panel': function(uploadCompleteData) {
                    this.confirmPanel = new Show.ConfirmPanel();
                    this.setConfirmPanelEvents(this.confirmPanel, this);
                    this.showConfirmPanel(this.confirmPanel, uploadCompleteData);
                },
                'show:failed:submission:panel': function() {
                    this.failedSubmissionPanel = new Show.FailedSubmissionPanel();
                    this.setFailedSubmissionPanelEvents(this.failedSubmissionPanel);
                    this.showFailedSubmissionPanel(this.failedSubmissionPanel);
                },
                'keen:completed:authorization': function(keenData) {
                    this.KeenData = _.extend(this.keenData, keenData);
                    App.execute('click:uploader', 'Completed authorization', this.keenData);
                }
            });
        },

        setFailedSubmissionPanelEvents: function(failedSubmissionPanel) {
            this.listenTo(failedSubmissionPanel, 'update:breadcrumb', function(step, backwards) {
                this.layout.onUpdateBreadcrumb(step, backwards);
            });
        },

        setFacebookSocialPhotoPanelEvents: function(socialPhotoPanel, options, type) {
            var _this = this;
            this.listenTo(socialPhotoPanel, {
                'get:focus:index': this.getFocusIndex.bind(this),
                'show:album:view': function(_view, _options) {
                    this.showSocialPhotoAlbumsPanel(this.socialPhotoAlbumsPanel, this);
                },
                'show:review:panel': function(source) {
                    this.source = source;
                    this.initReviewPanel(source);
                },
                'load:more': function(params) {
                    var perPage = 25;
                    var pagination = params.view.options.pagination;
                    if (type === 'photo') {
                        FB.api('/' + options.model.get('id') + '/photos?fields=images,name,id,created_time&after=' + pagination.nextUrl, 'get', {
                            access_token: Show.connectedUser.get('facebook_token')
                        }, function(response) {
                            response.data.forEach(function(data) {
                                data.type = 'image';
                                data.picture = data.images[0].source;
                                data.caption = data.name || '';
                            });
                            if (!_.isEmpty(response.paging) && !_.isEmpty(response.paging.cursors) && response.length >= perPage) {
                                pagination.next = true;
                                pagination.nextUrl = response.paging.cursors.after;
                            } else {
                                pagination.next = false;
                                pagination.nextUrl = null;
                            }
                            _this.photosCollection.add(response.data);
                            params.view.triggerMethod('loaded');
                        });
                    } else {
                        FB.api(pagination.nextUrl, 'get', {
                            access_token: Show.connectedUser.get('facebook_token')
                        }, function(response) {
                            response.data.forEach(function(data) {
                                data.type = 'video';
                            });
                            if (!_.isEmpty(response.paging) && !_.isEmpty(response.paging.cursors) && response.length >= perPage) {
                                pagination.next = true;
                                pagination.nextUrl = response.paging.cursors.after;
                            } else {
                                pagination.next = false;
                                pagination.nextUrl = null;
                            }
                            _this.videoCollection.add(response.data);
                            params.view.triggerMethod('loaded');
                        });
                    }
                }
            });
        },
        setFacebookSocialPhotoAlbumsPanelEvents: function(socialPhotoAlbumsPanel) {
            var _this = this;
            this.listenTo(socialPhotoAlbumsPanel, {
                'get:focus:index': this.getFocusIndex.bind(this),
                'update:breadcrumb': this.updateBreadcrumb.bind(this),
                'load:more': function(params) {
                    App.execute('get:facebook:albums', Show.connectedUser.get('facebook_token'), function(result, albumsPagination) {
                        _this.fbAlbumsCollection.add(result);
                        params.view.options.pagination = albumsPagination;
                        params.view.triggerMethod('loaded');
                    }, params.view.options.pagination.nextUrl);
                },
                'child:show:album:photos': function(view, options) {
                    FB.api('/' + options.model.get('id') + '/photos?fields=images,name,id,created_time', 'get', {
                        access_token: Show.connectedUser.get('facebook_token')
                    }, function(response) {
                        var perPage = 25;
                        var pagination = {
                            page: 1,
                            nextUrl: null,
                            next: false
                        };
                        response.data.forEach(function(data) {
                            data.type = 'image';
                            data.picture = data.images[0].source;
                            data.caption = data.name || '';
                        });
                        _this.photosCollection = new App.Entities.Collection(response.data);
                        if (!_.isEmpty(response.paging) && !_.isEmpty(response.paging.cursors) && response.data.length >= perPage) {
                            pagination.next = true;
                            pagination.nextUrl = response.paging.cursors.after;
                        }
                        _this.source = 'facebook';
                        _this.socialPhotoPanel = new Show.SocialPhotoPanel({
                            collection: _this.photosCollection,
                            uploaderCollection: _this.uploaderCollection,
                            source: _this.source,
                            pagination: pagination
                        });
                        var type = 'photo';
                        _this.setFacebookSocialPhotoPanelEvents(_this.socialPhotoPanel, options, type);
                        _this.showSocialPhotoPanel(_this.socialPhotoPanel);
                    });
                },
                'child:show:album:videos': function(view, options) {
                    FB.api('me/videos?fields=description,picture,source', 'get', {
                        access_token: Show.connectedUser.get('facebook_token')
                    }, function(response) {
                        var perPage = 25;
                        var pagination = {
                            page: 1,
                            nextUrl: null,
                            next: false
                        };
                        if (_.isFalsy(response)) {
                            _this.videoCollection = new App.Entities.Collection();
                        } else {
                            response.data.forEach(function(data) {
                                data.type = 'video';
                                data.caption = data.description || '';
                            });
                            _this.videoCollection = new App.Entities.Collection(response.data);
                            if (!_.isEmpty(response.paging) && !_.isEmpty(response.paging.cursors) && response.data.length >= perPage) {
                                pagination.next = true;
                                pagination.nextUrl = response.paging.next;
                            }
                        }
                        _this.source = 'facebook';
                        _this.socialPhotoPanel = new Show.SocialPhotoPanel({
                            collection: _this.videoCollection,
                            uploaderCollection: _this.uploaderCollection,
                            source: _this.source,
                            pagination: pagination
                        });
                        var type = 'video';
                        _this.setFacebookSocialPhotoPanelEvents(_this.socialPhotoPanel, options, type);
                        _this.showSocialPhotoPanel(_this.socialPhotoPanel);
                    });
                },
                'child:show:album:videos:uploaded': function(view, options) {
                    FB.api('me/videos?type=uploaded&fields=description,picture,source', 'get', {
                        access_token: Show.connectedUser.get('facebook_token')
                    }, function(response) {
                        var perPage = 25;
                        var pagination = {
                            page: 1,
                            nextUrl: null,
                            next: false
                        };
                        if (_.isFalsy(response)) {
                            _this.videoCollection = new App.Entities.Collection();
                        } else {
                            response.data.forEach(function(data) {
                                data.type = 'video';
                                data.caption = data.description || '';
                            });
                            _this.videoCollection = new App.Entities.Collection(response.data);
                            if (!_.isEmpty(response.paging) && !_.isEmpty(response.paging.cursors) && response.data.length >= perPage) {
                                pagination.next = true;
                                pagination.nextUrl = response.paging.next;
                            }
                        }
                        _this.source = 'facebook';
                        _this.socialPhotoPanel = new Show.SocialPhotoPanel({
                            collection: _this.videoCollection,
                            uploaderCollection: _this.uploaderCollection,
                            source: _this.source,
                            pagination: pagination
                        });
                        var type = 'video';
                        _this.setFacebookSocialPhotoPanelEvents(_this.socialPhotoPanel, options, type);
                        _this.showSocialPhotoPanel(_this.socialPhotoPanel);
                    });
                }
            });
        },
        setGooglePickerPanelEvents: function(googlePickerPanel) {
            this.listenTo(googlePickerPanel, {
                'update:breadcrumb': this.updateBreadcrumb.bind(this),
                'get:focus:index': this.getFocusIndex.bind(this),
                'picker:items:ready': this.ingestGooglePickerItems
            }, this);
        },
        setConfirmPanelEvents: function(confirmPanel) {
            this.listenTo(confirmPanel, {
                'update:breadcrumb': this.updateBreadcrumb.bind(this),
                'get:focus:index': this.getFocusIndex.bind(this),
            });
        },
        setPreviewMode: function() {
            var _this = this;
            var formPanelTriggers;
            var homePanelTriggers;
            var confirmPanelTriggers;
            App.commands.setHandler('stylesheet:generated', function(css, params) {
                //setting temp variable
                var _formPanelTriggers = {
                    'dob_display': params.dob_display
                };
                var _homePanelTriggers = {
                    'uploader_homePanel_backgroundImage': params.uploader_homePanel_backgroundImage
                };
                var _confirmPanelTriggers = {
                    'thankYou_image_backgroundImage': params.thankYou_image_backgroundImage,
                    'thankYouUrl_input': params.thankYouUrl_input
                };
                //initialize general variables
                formPanelTriggers = formPanelTriggers || _formPanelTriggers;
                homePanelTriggers = homePanelTriggers || _homePanelTriggers;
                confirmPanelTriggers = confirmPanelTriggers || _confirmPanelTriggers;
                //check for new changes and trigger corespending screen
                if (!_.isEqual(_formPanelTriggers, formPanelTriggers)) {
                    formPanelTriggers = _formPanelTriggers;
                    _this.formView = new Show.FormView({
                        model: Show.connectedUser,
                        collection: _this.uploaderCollection,
                        source: _this.source
                    });
                    _this.setFormViewEvents(_this.formView);
                    _this.showFormView(_this.formView);
                } else if (!_.isEqual(_homePanelTriggers, homePanelTriggers)) {
                    homePanelTriggers = _homePanelTriggers;
                    _this.homeView = new Show.Home();
                    _this.setHomeViewEvents(_this.homeView);
                    _this.showHomeView(_this.homeView);
                } else if (!_.isEqual(_confirmPanelTriggers, confirmPanelTriggers)) {
                    App.displayOptions.set('thankYouUrl_input', params.thankYouUrl_input);
                    confirmPanelTriggers = _confirmPanelTriggers;
                    _this.confirmPanel = new Show.ConfirmPAnel();
                    _this.setConfirmPanelEvents(_this.confirmPanel);
                    _this.showConfirmPanel(_this.confirmPanel);
                }
            });
        },
        getFocusIndex: function(element) {
            // if an element is not provided to this function, show the main content then get focus index
            if (_.isFalsy(element)) {
                this.layout.onShowMainContent();
            }
            this.layout.onGetFocusIndex(element);
        },
        updateBreadcrumb: function(step, backwards) {
            this.layout.onUpdateBreadcrumb(step, backwards);
        },
        showUploadHolderRegion: function(layoutView) {
            layoutView.onShowUploadHolder();
            layoutView.onHideMainContent();
        },
        showMainContentRegion: function(layoutView) {
            layoutView.onHideUploadHolder();
            layoutView.onShowMainContent();
        },
        showHomeView: function(homeView) {
            this.showMainContentRegion(this.layout);
            this.show(homeView, {
                region: this.layout.mainContent
            });
        },
        showLayout: function(layoutView) {
            this.show(layoutView, {
                loading: true
            });
        },
        showReviewPanel: function(reviewPanel) {
            this.showMainContentRegion(this.layout);
            this.show(reviewPanel, {
                region: this.layout.mainContent
            });
        },
        showProductSearchPanel: function(photo, source) {
            this.showMainContentRegion(this.layout);
            var panel = new Show.ProductSearchPanel({
                model: photo,
                source: source
            });
            this.listenTo(panel, {
                'done:tagging': function(model) {
                    if (!photo.has('products')) {
                        photo.set('products', new Backbone.Collection());
                    }
                    photo.get('products').add(model);
                    this.initReviewPanel(source);
                },
                'show:review:panel': function(source) {
                    this.source = source;
                    this.initReviewPanel(source);
                }
            });
            this.show(panel, {
                region: this.layout.mainContent
            });
        },
        showDragDropView: function(dragDropView) {
            this.showUploadHolderRegion(this.layout);
            this.show(dragDropView, {
                region: this.layout.uploadHolder
            });
        },
        showSocialPhotoPanel: function(socialPhotoPanel) {
            this.showMainContentRegion(this.layout);
            this.layout.mainContent.show(socialPhotoPanel);
        },
        showSocialPhotoAlbumsPanel: function(_socialPhotoAlbumsPanel) {
            //if the view is destroyed, then re-initialize it
            if (this.socialPhotoAlbumsPanel.isDestroyed) {
                this.socialPhotoAlbumsPanel = new Show.SocialPhotoAlbumPanel({
                    collection: this.fbAlbumsCollection,
                    pagination: this.albumsPagination
                });
                this.setFacebookSocialPhotoAlbumsPanelEvents(this.socialPhotoAlbumsPanel);
            }
            this.showMainContentRegion(this.layout);
            this.layout.mainContent.show(this.socialPhotoAlbumsPanel);
        },
        showGooglePickerPanel: function(googlePickerPanel) {
            this.showMainContentRegion(this.layout);
            this.layout.mainContent.show(googlePickerPanel);
        },
        showFormView: function() {
            //if the view is destroyed, then re-initialize it
            if (this.formView.isDestroyed) {
                this.formView = new Show.FormView({
                    model: Show.connectedUser,
                    collection: this.uploaderCollection,
                    source: this.source
                });
                this.setFormViewEvents(this.formView);
            }
            this.showMainContentRegion(this.layout);
            this.layout.mainContent.show(this.formView);
        },
        showConfirmPanel: function(confirmPanel, uploadCompleteData) {
            this.showMainContentRegion(this.layout);
            this.layout.mainContent.show(confirmPanel);

            this.uploadCompleteEvent(uploadCompleteData);
        },
        showFailedSubmissionPanel: function(failedSubmissionPanel) {
            this.showMainContentRegion(this.layout);
            this.layout.mainContent.show(failedSubmissionPanel);
        },
        showInfoPanel: function(infoPanel) {
            // hide main content so it doesn't get focus indexed for keyboard users
            this.layout.onHideMainContent();
            this.layout.extraContent.show(infoPanel);
        },
        uploadCompleteEvent: function(uploadCompleteData) {
            var data = _.isObject(uploadCompleteData) ? uploadCompleteData : {};
            var obj = {
                name: 'pixlee:upload:complete',
                type: 'action',
                source: 'uploader',
                destination: 'parent',
                data: data
            };

            window.top.postMessage(JSON.stringify(obj), '*');
        },
        initKeenData: function() {
            // Initial Keen Data
            this.keenSelectedChannel = false;
            this.keenData = {
                header_options: this.options.display_options.headerOptions,
                widget_type: this.options.display_options.type
            };
        },
        initUploaderCollections: function() {
            this.images = [];
            this.keenUploadedMedia = false;
            this.uploaderCollection = new App.Entities.Collection();
            this.photosCollection = new App.Entities.Collection();
            this.videoCollection = new App.Entities.Collection();
            this.fbAlbumsCollection = new App.Entities.Collection();
        },
        initFacebookSocialPhotoAlbumsPanel: function() {
            App.execute('get:facebook:albums', Show.connectedUser.get('facebook_token'), function(result, albumsPagination) {
                this.fbAlbumsCollection = new App.Entities.Collection(result);
                this.albumsPagination = albumsPagination;
                this.socialPhotoAlbumsPanel = new Show.SocialPhotoAlbumPanel({
                    collection: this.fbAlbumsCollection,
                    pagination: this.albumsPagination
                });
                this.setFacebookSocialPhotoAlbumsPanelEvents(this.socialPhotoAlbumsPanel);
                this.showSocialPhotoAlbumsPanel(this.socialPhotoAlbumsPanel);
            }.bind(this));
        },
        initGooglePickerPanel: function() {
            this.googlePickerPanel = new Show.GooglePickerPanel({
                token: Show.connectedUser.get('google_token'),
                uploaderCollection: this.uploaderCollection
            });
            this.initKeenData();
            this.keenData.channel = 'google_picker';
            App.execute('click:uploader', 'Select Secondary Source', this.keenData);
            this.setGooglePickerPanelEvents(this.googlePickerPanel);
            this.showGooglePickerPanel(this.googlePickerPanel);
        },
        // Picker hands the selection UI to Google. When polling resolves we get back the
        // picked items here; for each one we fetch the bytes as a Blob (Picker `baseUrl`
        // requires Authorization on every GET, so the backend cannot fetch the URL the
        // way it could for the deprecated Library API) and stash a File on the model's
        // `files` attribute. That puts Picker uploads on the same multipart pathway as
        // desktop drag-drop — the existing `desktopSubmit` in submit_content_validation
        // already handles POSTing `files[0]` to `api/v2/media/file`. The review panel
        // uses `dataUrl` (a blob: URL) for the preview thumbnail, same as desktop uploads.
        ingestGooglePickerItems: function(mediaItems) {
            var _this = this;
            var token = Show.connectedUser.get('google_token');
            // Each per-item deferred resolves after success or failed fetch so $.when().always()
            // runs only once everything settled — jQuery 1.x does not turn failed .then() branches
            // into resolutions like Promises/A+, and $.when() rejects on the first failing deferred.
            // Models are only added on success so desktopSubmit never sees a model without `files`.
            var bytePromises = _.map(mediaItems, function(item) {
                var mediaFile = item.mediaFile || {};
                if (!mediaFile.baseUrl) {
                    // Picker can return items with no usable baseUrl (very rare — expired
                    // session, restricted item). Nothing we can submit; skip silently.
                    return $.Deferred().resolve().promise();
                }
                // Picker requires a download suffix on baseUrl (=d for images, =dv for video).
                // Outer deferred always resolves so jQuery 1.x $.when() waits for every fetch:
                // inner fail handlers stay rejected (unlike Promises/A+), and $.when rejects
                // on the first failure if passed failing deferreds.
                var settled = $.Deferred();
                App.request(
                    'fetch:google:picker:blob',
                    token,
                    mediaFile.baseUrl,
                    item.type || 'PHOTO'
                )
                    .done(function(blob) {
                        var filename = mediaFile.filename || ('google-photo-' + item.id);
                        var mimeType = mediaFile.mimeType || 'image/jpeg';
                        var file = new File([blob], filename, { type: mimeType });
                        _this.uploaderCollection.add(new App.Entities.Model({
                            id: item.id,
                            source: 'google',
                            caption: mediaFile.filename || '',
                            mimeType: mimeType,
                            type: item.type || 'PHOTO',
                            dataUrl: URL.createObjectURL(blob),
                            files: [file]
                        }));
                        settled.resolve();
                    })
                    .fail(function(err) {
                        // Log only; do not add to uploaderCollection — desktopSubmit must not
                        // see a model without files.
                        if (typeof Sentry !== 'undefined') {
                            Sentry.captureMessage('Failed to download Google Picker item', {
                                tags: { source: 'google' },
                                contexts: {
                                    item: { id: item.id, filename: mediaFile.filename },
                                    response: { status: err && err.status }
                                }
                            });
                        }
                        settled.resolve();
                    });
                return settled.promise();
            });
            $.when.apply($, bytePromises).always(function() {
                if (!_this.uploaderCollection.length) {
                    // Every picker item failed to download (or had no baseUrl). Don't
                    // drop the user into an empty review panel — surface the failure on
                    // the still-visible picker panel and let them retry.
                    if (_this.googlePickerPanel && !_this.googlePickerPanel.isDestroyed) {
                        _this.googlePickerPanel.showError(
                            'Could not download your selected Google Photos. Please try again.'
                        );
                    }
                    return;
                }
                _this.initReviewPanel('google');
            });
        },

        initReviewPanel: function(source) {
            this.reviewPanel = new Show.ReviewPanel({
                collection: this.uploaderCollection,
                model: Show.connectedUser,
                source: source
            });
            this.setReviewPanelEvents(this.reviewPanel);
            this.showReviewPanel(this.reviewPanel, source);
            // Keen Tracking
            if (!this.keenUploadedMedia) {
                this.keenData = {
                    channel: source,
                    email: Show.connectedUser.get('email_address'),
                    name: Show.connectedUser.get('full_name'),
                    user_handle: Show.connectedUser.get('facebook_user_name'),
                    number_of_media: this.uploaderCollection.length
                };
                this.keenUploadMediaDebounce(this.keenData);
            }
        },
        keenUploadMedia: function(keenData) {
            this.keenUploadedMedia = true;
            App.execute('click:uploader', 'Uploaded media', keenData);
        },
        keenMapStep: function(step) {
            switch (step) {
                case 'one':
                    return 'Choose Source';
                case 'two':
                    return 'Select Content';
                case 'three':
                    return 'Review Submission';
                case 'four':
                    return 'Submit Content';
                default:
                    return '';
            }
        }
    });
});
